const getDisplayNameFromUrl = (templateId: string) => {
  if (/^\d+$/.test(templateId)) {
    return '';
  }

  const titlePart = templateId.replace(/-\d+$/, '');
  return titlePart
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export default getDisplayNameFromUrl;
